export const SIDEBAR_DRAWER_BACKGROUND_COLOR = '#F4F5FF'
export const SIDEBAR_FONT_COLOR = 'rgba(78, 78, 97, 1)'
